<div id="fullScreenContainer">
  <div #videoContainer id="video-player">
    <eocm-warning-bar [message]="getWarningMessage()"></eocm-warning-bar>
    <eocm-video></eocm-video>
    <eocm-timeline *ngIf="preview !== 'play-scene' && !isInMobilePreviewMode"></eocm-timeline>
  </div>
</div>
